import { render, staticRenderFns } from "./BooleanQuestion.vue?vue&type=template&id=06ae9516"
import script from "./BooleanQuestion.vue?vue&type=script&lang=js"
export * from "./BooleanQuestion.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports